import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom";

import { myAxios } from "src/components/common/functions";

export async function rentalsLoader({ request }: LoaderFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => controller.abort());
    const url = new URL(request.url);
    let shouldRedirect = false;
    const now = new Date();
    const monthStart = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-01`;
    const today = now.toISOString().slice(0, 10);
    const allowed = ["page", "limit", "status", "rentalStartDateFrom", "rentalStartDateTo"];
    for (const [key] of url.searchParams) {
        if (!allowed.includes(key)) {
            url.searchParams.delete(key);
            shouldRedirect = true;
        }
    }
    if (!url.searchParams.get("page")) {
        url.searchParams.set("page", "1");
        shouldRedirect = true;
    }
    if (!url.searchParams.get("limit")) {
        url.searchParams.set("limit", "10");
        shouldRedirect = true;
    }
    if (!url.searchParams.get("status")) {
        url.searchParams.set("status", "all");
        shouldRedirect = true;
    }
    if (!url.searchParams.get("rentalStartDateFrom")) {
        url.searchParams.set("rentalStartDateFrom", monthStart);
        shouldRedirect = true;
    }
    if (!url.searchParams.get("rentalStartDateTo")) {
        url.searchParams.set("rentalStartDateTo", today);
        shouldRedirect = true;
    }
    if (shouldRedirect) {
        throw redirect(url.pathname + "?" + url.searchParams.toString());
    }
    const formData = new FormData();
    for (const key of allowed) {
        const value = url.searchParams.get(key);
        if (value !== null) formData.append(key, value);
    }
    const res = await myAxios({
        fileName: "rentalStatus/readRentals.php",
        formData,
        signal: controller.signal,
    });
    if (!res) throw redirect("..");
    return res.data;
}

export async function rentalLoader({ params, request }: LoaderFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => controller.abort());
    if (!params.id) throw redirect("/RentalStatus");
    const formData = new FormData();
    formData.append("id", params.id);
    const res = await myAxios({
        fileName: "rentalStatus/readRental.php",
        formData,
        signal: controller.signal,
    });
    if (!res || !res.data) throw redirect("..");
    return { rental: res.data };
}

const rentalUrlMap = {
    Add: "rentalStatus/createRental.php",
    Edit: "rentalStatus/updateRental.php",
} as const;

export async function rentalAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => controller.abort());
    const formData = await request.formData();
    const action = String(formData.get("action") ?? "");
    const fileName = rentalUrlMap[action as keyof typeof rentalUrlMap];
    if (!fileName) {
        window.alert("Invalid rental action.");
        return null;
    }
    if (!formData.get("equipmentName")) {
        window.alert("Equipment is required.");
        return null;
    }
    if (!formData.get("projectId")) {
        window.alert("Project is required.");
        return null;
    }
    if (!formData.get("renterId")) {
        window.alert("Technician is required.");
        return null;
    }
    const res = await myAxios({
        fileName,
        formData,
        signal: controller.signal,
    });
    if (!res) return null;
    return redirect(action === "Add" ? `/RentalStatus/${res.data.id}` : "..");
}

export async function returnAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => controller.abort());
    const formData = await request.formData();
    const action = String(formData.get("action") ?? "");
    const fileName = action === "Return" ? "rentalStatus/createReturn.php" : action === "Edit Return" ? "rentalStatus/updateReturn.php" : "";
    if (!fileName) {
        window.alert("Invalid return action.");
        return null;
    }
    if (!formData.get("id")) {
        window.alert("Missing rental id.");
        return null;
    }
    if (!formData.get("returnedById")) {
        window.alert("Returned by is required.");
        return null;
    }
    if (!formData.get("rentalReturnDate")) {
        window.alert("Return date is required.");
        return null;
    }
    const res = await myAxios({
        fileName,
        formData,
        signal: controller.signal,
    });
    if (!res) return null;
    return redirect("..");
}
